export const BNK_STMT_updateMonthlyStatementErrReducer = {
  BNK_STMT_updateMonthlyStatementErr: (state, action) => {
    state.monthlyStatementErr = action.payload;
  },
};
